import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "./src//redux/store"
import AppRoot from "./src/App"
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./src/index.css";
import "./src/App.css"
function App() {
    return (
        <Provider store={store}>
            <BrowserRouter>
                {/* <MaintanenceMode /> */}
                <AppRoot />
            </BrowserRouter>
        </Provider>
    );
}

ReactDOM.createRoot(document.getElementById("app")).render(<App />);
